import React, { Component } from 'react';
import Logo from './Logo';
import EqualHousingOpportunity from './EqualHousingOpportunity';
import UhmFooter from './UhmFooter';
export class Error extends Component {
    static displayName = Error.name;

    constructor(props) {
        super(props);
        this.state = { };
    }

    componentDidMount() {

    }

    render() {

        return (
            <div>
                <div class="wrapper">
                    <Logo/>
                    <div class="content">
                        <h1>We're sorry, something went wrong</h1>
                        <h2 class="">Please close this window and try again using the email link. If the problem persists please reach out to us at <span><a href="tel:1-877-846-4968">1-877-846-4968</a></span></h2>
                    </div>
                    <div class="footer">
                        <UhmFooter />
                        <EqualHousingOpportunity />
                    </div>
                </div>
                <div class="errorImg"></div>
            </div>
        );
    }
}
